// DisconnectCard.jsx
import React from "react";
import bgImage from "../img/bg.png";

function DisconnectCard({ title, text, version = "Bytewave-Client @ v1.0.0" }) {
  return (
        <div
          className="flex flex-col items-center justify-center min-h-screen relative bg-cover bg-center"
          style={{ backgroundImage: `url(${bgImage})` }}
        >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

      <div className="relative z-10 bg-gray-900/80 backdrop-blur-md shadow-xl rounded-xl p-10 w-[90%] max-w-md text-center border border-white/10">
        <h2 className="text-2xl font-bold mb-4 text-red-500 tracking-wide">{title}</h2>
        <p className="text-gray-300 text-base leading-relaxed mb-6">{text}</p>
        <p className="text-gray-400 text-xs mt-4">{version}</p>
      </div>
    </div>
  );
}

export default DisconnectCard;
